<template>
  <TableComp
    v-if="backups"
    :name="$t('global.daily-backups')"
    :headers="headers"
    :status="backupsStatus"
    :number-of-items="backups.length"
    empty-image="backups"
    :empty-bold-message="$t('global.no-daily-backups-bold-message')"
    :empty-message="$t('global.no-daily-backups-message')"
    v-on:update:list="updateList"
  >
    <template #desktop>
      <tr v-for="(backup, index) in backups" v-bind:key="index">
        <td>
          <span class="mr-2">{{ site.domain }}</span>
          <CopyToClipboard :text="site.domain" />
        </td>

        <td class="text-center">
          <span class="mr-2">{{ getDate(backup) }}</span>
        </td>

        <td class="text-end actions">
          <div v-if="backupsStatus.isLoaded" class="d-flex justify-content-end mr-4">
            <ThreeDotsMenu :items="menuItems(backup)" />
          </div>
          <LoadingState v-else :size="iconSize" />
        </td>
      </tr>
    </template>
    <template #mobile>
      <TableMobileRow v-for="(backup, index) in backups" v-bind:key="index">
        <template #header>
          <div class="d-flex align-items-center">
            <!-- site domain column -->
            <div class="flex-fill">
              <div class="d-flex align-items-center">
                <span class="mr-2">{{ site.domain }}</span>
                <CopyToClipboard :text="site.domain" />
              </div>
            </div>

            <!-- dropdown menu column -->
            <div class="d-flex justify-content-center">
              <ThreeDotsMenu :items="menuItems(backup)" />
            </div>
          </div>
        </template>
        <template #content>
          <!-- backup domain -->
          <div class="row">
            <div class="col">{{ $t("global.domain") }}:</div>
            <div class="col">
              <span class="mr-2">{{ site.domain }}</span>
              <CopyToClipboard :text="site.domain" />
            </div>
          </div>

          <!-- backup date -->
          <div class="row">
            <div class="col">{{ $t("global.date") }}:</div>
            <div class="col">{{ getDate(backup) }}</div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import BackupRestoreDailyModal from "@/components/smart/modals/BackupRestoreDaily";
import constants from "@/utils/constants";
import CopyToClipboard from "@/components/display/CopyToClipboard";
import { dateFormat } from "leatherman-js/utils/formatters/time";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import ThreeDotsMenu from "@/components/display/ThreeDotsMenu";

export default {
  name: "FullBackupsTable",
  props: {
    backups: Array,
    backupsStatus: Object,
    site: Object,
  },
  components: {
    TableComp,
    TableMobileRow,
    CopyToClipboard,
    ThreeDotsMenu,
    LoadingState,
  },
  setup(props, { root }) {
    const headers = [
      new TableHeader(root.$t("global.domain")),
      new TableHeader(root.$t("global.status"), "justify-content-center"),
      new TableHeader(root.$t("global.date"), "justify-content-center"),
      new TableHeader(),
    ];

    const getDate = (backup) => dateFormat(backup.filedate / 1000, true);

    const restoreFromBackup = (backup) => {
      store.dispatch("modals/open", {
        template: BackupRestoreDailyModal,
        data: { site: props.site, backup },
      });
    };

    const menuItems = (backup) => {
      return [new NavLink(root.$t("global.restore"), null, () => restoreFromBackup(backup))];
    };

    const updateList = () => {
      store.dispatch("backups/getDailyList", props.site.id);
    };

    const iconSize = constants.TABLE_ICON_SIZE;

    return {
      headers,
      updateList,
      getDate,
      menuItems,
      iconSize,
    };
  },
};
</script>
